import { C } from '../constants';

// Desktop two-column shell: left sidebar + right content
export const DesktopShell = ({ children }) => (
  <div style={{ position: 'fixed', inset: 0, display: 'flex', background: C.bg0, overflow: 'hidden', WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}>
      {children}
  </div>
);

export const DesktopSidebar = ({ children, width = '30%', flex }) => (
  <div className="desktop-sidebar" style={{ width, flexShrink: 0, display: 'flex', flexDirection: 'column', ...(flex ? { flex: 1, minHeight: 0 } : { height: '100%' }), background: C.bg1, ...(flex ? {} : { borderRight: `1px solid ${C.bd}` }), overflow: 'hidden' }}>
    {children}
  </div>
);

export const DesktopMain = ({ children }) => (
  <div className="desktop-main-right" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden', background: C.bg0 }}>
    {children}
  </div>
);

export const DesktopTopBar = ({ title, left, right }) => (
  <div className="topbar desktop-topbar" style={{ display: 'flex', alignItems: 'center', gap: 10, background: C.bg0, borderBottom: `1px solid ${C.bd}`, flexShrink: 0 }}>
    {left && <div>{left}</div>}
    <div style={{ flex: 1, fontSize: 15, fontWeight: 700, color: '#E8F4FF' }}>{title}</div>
    {right && <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{right}</div>}
  </div>
);

export const DesktopContent = ({ children }) => (
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px 60px', fontSize: 13 }}>
    {children}
  </div>
);

export const DesktopSidebarContent = ({ children, scrollRef, onScroll }) => (
  <div ref={scrollRef} onScroll={onScroll} style={{ flex: 1, overflowY: 'auto', padding: '0 0 80px' }}>
    {children}
  </div>
);
